import * as React from 'react'

import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const columns = [
  {
    id: 'name',
    attribute: 'name',
    name: () => i18n.t('finance.dimension_detail.table.name'),
    colSpan: 3,
    sortable: true,
  },
  {
    id: 'employees',
    attribute: 'employees',
    name: () => i18n.t('finance.dimension_detail.table.employees'),
    colSpan: 2,
    sortable: true,
    alignRight: true,
  },
  {
    id: 'legalEntity',
    attribute: 'legalEntity',
    name: () => i18n.t('finance.dimension_detail.table.legal_entity'),
    colSpan: 3,
    sortable: true,
  },
  {
    id: 'code',
    attribute: 'code',
    name: () => i18n.t('finance.dimension_detail.table.code'),
    colSpan: 3,
    sortable: false,
  },
  {
    id: '',
    attribute: 'description',
    name: () => i18n.t('finance.dimension_detail.table.description'),
    colSpan: 3,
    sortable: false,
  },
]

interface Props {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

const Header = ({ onSort, attribute, direction }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        {columns.map((column) =>
          column.sortable ? (
            <Table.SortableHeadCell
              key={column.id}
              attribute={column.attribute}
              colSpan={column.colSpan}
              onSort={onSort}
              sortAttribute={attribute}
              sortDirection={direction}
              justifyContent={column.alignRight ? 'flexEnd' : 'flexStart'}
            >
              {column.name()}
            </Table.SortableHeadCell>
          ) : (
            <Table.HeadCell key={column.id} colSpan={column.colSpan}>
              {column.name()}
            </Table.HeadCell>
          )
        )}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default Header
